import { apiQuery } from '../services/backendApi'
import auth0 from 'auth0-js'

const getLoginRedirectURI = () => {
  return window.location.protocol + '//' + window.location.host
}

export const loginDomain = 'auth.glue.work'
const cognotoLoginDomain = 'auth2.glue.work'

const webAuth = new auth0.WebAuth({
  domain: loginDomain,
  clientID: 'WwE5FyYTZXJUV0W3Hv4MBl0wvsgpOtNL',
  redirectUri: getLoginRedirectURI() ?? window.location.protocol + '//' + window.location.host,
  responseType: 'id_token',
  scope: 'openid id_token profile email'
})

const authorizeUserViaConnection = (connectionName, rawRedirectURI = null, identityProvider = null) => {
  if (connectionName === 'aws-cognito' && identityProvider) {
    // For cognito, use GlueOS URL as redirectUri
    // Cognito does not allow passing parameters to redirect URL. Instead, parameters must be packed to specific state-parameter and unpacked in other end
    const glueOSURL = new URL(window.sessionStorage.getItem('glueOSUri') ?? rawRedirectURI)
    const redirectUri = glueOSURL.origin
    const glueOSParams = btoa(glueOSURL.search)

    window.location.href = 'https://' + cognotoLoginDomain + '/authorize?response_type=code&identity_provider=' + identityProvider.identityProviderName + '&client_id=' + identityProvider.clientId + '&redirect_uri=' + redirectUri + '&state=' + glueOSParams
  } else {
    webAuth.authorize({
      connection: connectionName,
      ...(rawRedirectURI ? { rawRedirectURI: rawRedirectURI } : {})
    })
  }
}

export const authorizeTrialOrgUser = async (teamConfirmationToken) => {
  const res = await apiQuery('/authenticated', { teamConfirmationToken: teamConfirmationToken }).catch(e => null)
  return res
}

export const handleNewUser = async (args) => {
  const res = await apiQuery('/authenticated', { acceptInvitation: args.acceptInvitation, orgId: args.orgId }).catch(e => null)
  return res
}

/**
 * Try to find out which auth connection if any the login process should use.
 * @param {string} email Email address of user
 * @returns {string | null} Connection name if found, null if not
 */
const tryDiscoverAuthConnectionNameForEmail = async (email) => {
  const res = await apiQuery('/authenticated', { authConnectionNameForUser: email }).catch(e => null)
  return res
}

export const trySSOLogin = async (email) => {
  const connectionSettings = await tryDiscoverAuthConnectionNameForEmail(email)
  const connectionName = connectionSettings?.connectionName
  if (!connectionName) {
    return false
  }

  // Force enable keyboard input
  if (window.vuplex) {
    window.vuplex.postMessage({
      topic: 'Enable textfield',
      args: JSON.stringify({ value: true })
    })
  }

  console.log('Using SSO login', connectionName)
  const redirectURI = getLoginRedirectURI()
  authorizeUserViaConnection(connectionName, redirectURI, connectionSettings.identityProvider)

  return true
}

export const login = async (email, password, onError) => {
  // I'm assuming we're trying SSO login again here, because it might have failed earlier
  // due to the user typoing their email address
  if (!await trySSOLogin(email)) {
    console.log('Using database login')
    const redirectURI = getLoginRedirectURI()
    webAuth.login({ email: email, password: password, redirectUri: redirectURI }, onError)
  }
}

export const loginWithGoogle = async () => {
  const redirectURI = getLoginRedirectURI()
  authorizeUserViaConnection('google-oauth2', redirectURI)
}

export const logout = () => {
  window.localStorage.removeItem('idToken')
  webAuth.logout({ returnTo: window.location.protocol + '//' + window.location.host + '?logoutComplete=true' })
}

export const validateToken = async () => {
  const res = await apiQuery('/authenticated', { validateToken: true }).catch(e => null)
  return res
}
